import { useCallback, useState } from "react";
import ReportDocumentPreview from "../components/Reporting/ReportDocumentPreview";

// Opens a document attached to a report item, such as a finding, in a
// preview modal, where previous and next step through the other documents
// it was opened with. Render `preview` somewhere on the page: it holds the
// modal while one is open.
function useReportDocumentOpener(tenantKey: string, folderId?: string) {
	const [opened, setOpened] = useState<{
		documents: any[];
		index: number;
	} | null>(null);

	// Opens doc, among documents when it is one of them, otherwise alone.
	const openDocument = useCallback((doc: any, documents?: any[]) => {
		const index = documents?.indexOf(doc) ?? -1;
		setOpened(
			documents && index !== -1
				? { documents, index }
				: { documents: [doc], index: 0 }
		);
	}, []);

	const preview = opened ? (
		<ReportDocumentPreview
			tenantKey={tenantKey}
			folderId={folderId}
			documents={opened.documents}
			index={opened.index}
			onIndexChange={(index) =>
				setOpened((prev) => (prev ? { ...prev, index } : prev))
			}
			onClose={() => setOpened(null)}
		/>
	) : null;

	return { openDocument, preview };
}

export default useReportDocumentOpener;
